'use strict';

module.exports = Number.MAX_SAFE_INTEGER || 9007199254740991; // Math.pow(2, 53) - 1;



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/maxSafeInteger.js
// module id = 8uaX
// module chunks = 78